import { Buffer } from 'buffer'
/** Minecraft uses Java BigInteger's signed hexadecimal SHA-1 representation. */
export async function sessionHash(serverId: string, sharedSecret: Uint8Array, publicKey: Uint8Array) {
  const bytes = Buffer.concat([Buffer.from(serverId, 'latin1'), Buffer.from(sharedSecret), Buffer.from(publicKey)])
  const digest = new Uint8Array(await globalThis.crypto.subtle.digest('SHA-1', Uint8Array.from(bytes).buffer))
  const hex = Array.from(digest, x => x.toString(16).padStart(2, '0')).join('')
  let value = BigInt('0x' + hex)
  if (digest[0] & 0x80) value -= 1n << 160n
  return value.toString(16)
}
